import { useMemo } from 'react';

import { Modal, Text } from '@thefarmersfront/kitchen';

import { InfoText, ResultStatusSummary, Table } from '~/components/common';

import { getDeliveryAgencyTrackingCancelFailColumnDefs } from '~/utils/delivery-agency/table';

import type {
  TypePostShippingLabelsCancelResponse,
  TypeShippingLabelCancelFailure,
} from '~/types/delivery-agency.types';

import styles from './DeliveryAgencyTrackingCancelFailModal.module.scss';

const FAIL_TABLE_HEIGHT = 396;

type TypeCancelFailData = NonNullable<TypePostShippingLabelsCancelResponse['data']>;

const DeliveryAgencyTrackingCancelFailModal = ({
  data,
  open,
  onClose,
}: {
  data: TypeCancelFailData;
  open: boolean;
  onClose: () => void;
}) => {
  const { columnDefs } = useMemo(() => getDeliveryAgencyTrackingCancelFailColumnDefs(), []);

  const hasStatusUnavailable = data.failureGroups.some((group) => group.reason === 'STATUS_UNAVAILABLE');

  const needOrderCancelFailures = data.failureGroups
    .filter((group) => group.reason === 'NEED_ORDER_CANCEL')
    .flatMap((group) => group.failures);

  return (
    <Modal title="취소 불가 상세" size="xlarge" open={open} onConfirm={onClose}>
      <div className={styles['contents-container']}>
        <ResultStatusSummary totalCount={data.totalCount} successCount={data.successCount} failCount={data.failCount} />
        <div className={styles['info-text-container']}>
          {hasStatusUnavailable && <InfoText>배송을 시작했거나, 이미 취소된 운송장은 취소 불가합니다.</InfoText>}
          <InfoText>
            출고번호에 속한 운송장을 모두 배송 취소하는것은 불가합니다. 모든 운송장을 취소해야할 경우{' '}
            <Text size="small" weight="semi-bold" color="secondary" element="span">
              배송 주문 관리
            </Text>{' '}
            화면에서 주문취소를 진행해 주세요.
          </InfoText>
        </div>
        <div className={styles['table-container']}>
          <Text size="large" weight="semi-bold">
            주문취소 필요 건
          </Text>
          <Table<TypeShippingLabelCancelFailure>
            data={needOrderCancelFailures}
            columns={columnDefs}
            height={FAIL_TABLE_HEIGHT}
          />
        </div>
      </div>
    </Modal>
  );
};

export default DeliveryAgencyTrackingCancelFailModal;
